import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators, NgForm, FormControl} from '@angular/forms';

import {AppserviceService} from 'src/app/appservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as myGlobals from 'src/app/globals';

@Component({
  selector: 'app-partsusage',
  templateUrl: './partsusage.component.html',
  styleUrls: ['./partsusage.component.sass']
})
export class PartsusageComponent implements OnInit {
  feEngineers = [];
  movefrom = [];
  partsData = [];
  feEngineersmovefrom = [];
  norecords:boolean = false;
  norecordsMsg = '';
  partselected = '';
  partselectedBool:boolean = false;
  partsUsageObj = {};
  partsusageform:any;
  partsUsageModel = {
    'consignmentno':'',
    'workorderid':'',
    'from_store':''
  };

  partUpdateBool:boolean = false;
  partUpdateMsg = '';
  partUpclass = '';

  constructor(private _formBuilder: FormBuilder, private AppService:AppserviceService, private spinner:NgxSpinnerService) { }

  movechangefn(event){
    //console.log(event.target.value, event.target.value.length);
    var _sV = event.target.value.toUpperCase();
      if(event.target.value.length === 1){
        this.movefrom = Object.assign([], this.feEngineers).filter(item => {
          //if(event.target.value.length == 1){
            //console.log(item['name'], item['name'].charAt(0) === _sV);
            if(_sV === item['name'].charAt(0)){
              //console.log(item);
              return item;
            }
        });
      }else{
        this.movefrom = Object.assign([], this.feEngineers).filter(item => {
          //if(event.target.value.length == 1){
            //console.log(item['name'].indexOf(event.target.value));
            if(item['name'].indexOf(_sV) > -1){
              //console.log(item);
              return item;
            }
        });
      }
  }

  fetchParts(engg){
    this.spinner.show();
    this.AppService.getParts(engg).subscribe((partsData) => {
      this.spinner.hide();
      this.partsData = partsData['data'];
      //console.log(this.partsData.length);
      if(this.partsData.length != 0){
        this.norecords = true;
      }else{
        this.norecords = false;
        this.norecordsMsg = 'No parts found for transfer!';
      }
    },
    (error) => {
      this.spinner.hide();
      console.log(error);
    });
  }

  selectPart(part){
    this.partsUsageObj['from_store'] = this.partsusageform.value.from_store;
    this.partsUsageObj['part_code'] = part.bis_part;
    this.partselected = part.bis_part;
    this.partselectedBool = true;
    //console.log(this.partsUsageObj, part);
  }

  deletePartFromUser(part){
    var that = this;
    this.partsData.forEach(function(item,index){
      if(item['bis_part'] === part){
        that.partsData.splice(index,1);
      }
    });
  }  

  partUsage(){
    this.partsUsageObj['wo_id'] = this.partsusageform.value.workorderid;
    this.partsUsageObj['consignment_code'] = this.partsusageform.value.consignmentno;
    this.partsUsageObj['qty'] = 1;
    console.log(this.partsUsageObj);
    /* const partsObj = {
      'partupdate':this.partsUsageObj
    } */
    this.spinner.show();
    this.AppService.partsUpdate(this.partsUsageObj).subscribe(
      (partsData) => {
        this.spinner.hide();
        console.log(partsData);
        this.partUpdateBool = partsData['success'];
        this.partUpdateMsg =  myGlobals.appMessages['partsusage']['success'] + ' ' + this.partsUsageObj['wo_id'];//partsData['message'];
        this.partUpclass = myGlobals.appMessages['classes']['success'];
        this.partselectedBool = false;
        this.partselected = '';
        this.deletePartFromUser(this.partsUsageObj['part_code']);
      },
      (err) => {
        this.spinner.hide();
        console.log(err);
        this.partUpdateBool = true;
        this.partUpdateMsg = myGlobals.appMessages['partsusage']['error'];
        this.partUpclass = myGlobals.appMessages['classes']['error'];
      }
    );
  }

  searchWO(wo){
    //console.log(wo.target.value);
  }

  ngOnInit() {
    this.partsusageform = new FormGroup({
      'consignmentno':new FormControl(this.partsUsageModel.consignmentno,[
        Validators.required
      ]),
      'workorderid':new FormControl(this.partsUsageModel.workorderid,[
        Validators.required
      ]),
      'from_store':new FormControl(this.partsUsageModel.from_store,[
        Validators.required
      ])
    });
    this.feEngineers = this.movefrom = this.AppService.getEngData();
    //console.log(this.feEngineers, this.movefrom);
  }

}
